import React, { Component } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "./common/loader";
import API from "../services/api";

class appDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingCostSyncStatus: true,
      isCostSyncRunning: false,
    };
  }

  updateInterval = null;

  loadSettings = async () => {
    return API.getSettings().then(async (response) => {
      this.setState({
        isCostSyncRunning: !!response.data.data?.costSyncIsRunning,       
      })
    }).finally(() => {
      this.setState({
        isLoadingCostSyncStatus: false
      })
    })
  }

  componentDidMount = async() => {
    this.loadSettings()
    if (!this.updateInterval) {
      this.updateInterval = setInterval(() => {
        this.loadSettings()
      }, 5000)
    }
  }

  componentWillUnmount = () => {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
  }

  render() {
    return (
      <div className="container">
        <div className="row pt-4">
          <div className="col-4"></div>
          <div className="col-4">
            <h3>App Dashboard</h3>
          </div>
          <div className="col-4"></div>
        </div>
        <div className="row pt-4">
          <div className="col-4">
            <div
              className="card bg-light mb-3"
              style={{
                maxWidth: 18 + "rem",
              }}
            >
              <div className="card-body">
                <h5 className="card-title">Create Products</h5>
                <p className="card-text">
                  Upload a CSV File with one or more products to create in
                  Fulfil.
                </p>
                <Link className="stretched-link" to="/imports-list" />
              </div>
            </div>
          </div>
          <div className="col-4">
            <div
              className="card bg-light mb-3"
              style={{
                maxWidth: 18 + "rem",
              }}
            >
              <div className="card-body">
                <h5 className="card-title">Update Products</h5>
                <p className="card-text">
                  Upload a CSV File with one or more products to update in
                  Fulfil.
                </p>
                <Link className="stretched-link" to="/product-updater" />
              </div>
            </div>
          </div>
          <div className="col-4">
            <div
              className="card bg-light mb-3"
              style={{
                maxWidth: 18 + "rem",
              }}
            >
              <div className="card-body">
                <h5 className="card-title">Cost Sync</h5>
                <p className="card-text">
                  {this.isLoadingCostSyncStatus 
                    ? <Loader isInline={true} /> 
                    : (this.state.isCostSyncRunning ? <b>Cost Sync is running</b> : "Cost Sync is not running") }
                </p>
                <Link className="stretched-link" to="/cost-sync" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default appDashboard;
